<template>
  <CellList
    key="`infinite_cell_list__`"
    :cell-list="contextList"
    :thumbnail-info="thumbnailInfo"
    :container-class-name="containerClassName"
    :content-info="contentInfo"
    :loading="loading"
    @cell-click-log="sendCellClickLog"
  />
</template>
<script setup>
  import { defineProps } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import {
    sendEventLogSearchListCell,
    sendEventLogSearchEditorPickCell,
  } from '@/common/util/log.v2.send'
  import CellList from '@/components/section/template/cell/CellList'

  defineProps({
    contextList: {
      type: Array,
      default: () => [],
      required: true,
    },
    thumbnailInfo: {
      type: Object,
      default: () => {},
      required: true,
    },
    containerClassName: {
      type: String,
      default: '',
    },
    contentInfo: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  })

  const route = useRoute()

  const sendCellClickLog = ({ cellInfo = {}, index = -1, routeName = '' }) => {
    route.query.searchCategory === 'theme-list'
      ? sendEventLogSearchEditorPickCell({
          cellInfo: cellInfo,
          index: index,
          route: route,
        })
      : sendEventLogSearchListCell({
          cellInfo: cellInfo,
          index: index,
          route: route,
        })
  }
</script>
